import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49e00169"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", {
  "data-animation": "fadeIn",
  class: "prediction__header"
}, "Prediction", -1))
const _hoisted_2 = { "data-animation": "fadeUp" }
const _hoisted_3 = { class: "prediction__title" }
const _hoisted_4 = { class: "prediction__desc" }


const __default__ = {
  name: 'ChapterPrediction',
};

import { Prediction } from '@/types/chapter';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: Object as () => Prediction,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.data)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["prediction", __props.data.layout === 'right' && 'is-right'])
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(__props.data.title), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(__props.data.description), 1)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})